<template>
  <div class="tw:relative tw:w-fit tw:inline-block tw:md:inline-flex tw:md:items-center">
    <select
      id="property-description-language-select"
      v-model="selectedLanguageCode"
      class="tw:cursor-pointer tw:appearance-none tw:rounded-lg tw:border tw:border-blue-700 tw:bg-blue-700 tw:py-2 tw:pr-14 tw:pl-8 tw:text-sm tw:font-bold tw:text-white tw:transition-colors tw:duration-300 tw:field-sizing-content"
      data-testid="property-description-language-select"
      :aria-label="$t(ctaLabelKey)"
      @change="handleLanguageChange">
      <option disabled value="">{{ $t(ctaLabelKey) }}</option>
      <option v-for="language in availableLanguages" :key="language.language" :value="language.language">
        {{ language.translatedLabel }}
      </option>
    </select>
    <svg
      class="tw:pointer-events-none tw:absolute tw:right-8 tw:top-1/2 tw:-translate-y-1/2"
      width="10"
      height="7"
      viewBox="0 0 10 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M1.25 1.75L5 5.5" stroke="white" stroke-width="2" stroke-linecap="round" />
      <path d="M8.75 1.75L5 5.5" stroke="white" stroke-width="2" stroke-linecap="round" />
    </svg>
  </div>
</template>

<script setup>
import { ref } from 'vue'

import { usePropertyDescriptions } from '@/components/propertyDetails/propertyDescriptions/usePropertyDescriptions'

const { availableLanguages, getLanguageByCode } = usePropertyDescriptions()

defineProps({
  ctaLabelKey: {
    type: String,
    default: 'description_language_cta',
    validator: value => ['description_language_cta', 'description_language_new_cta'].includes(value),
  },
})

const emit = defineEmits(['languageSelected'])

const selectedLanguageCode = ref('')

const handleLanguageChange = () => {
  const selectedLanguage = getLanguageByCode(selectedLanguageCode.value, availableLanguages.value)

  if (selectedLanguage) {
    emit('languageSelected', selectedLanguage)
  }

  selectedLanguageCode.value = ''
}
</script>
